import { render } from "./FindPassword.vue?vue&type=template&id=6db9da5c"
import script from "./FindPassword.vue?vue&type=script&lang=js"
export * from "./FindPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__